// extracted by mini-css-extract-plugin
export default {"container":"NavbarMobile_container__sYG8C","burger":"NavbarMobile_burger__8UtPN","options":"NavbarMobile_options__LmTAc"};